import ItemActions from './ItemActions'

module.exports = ItemActions.create( { 
  parentName : 'project', 
  itemsName : 'systems', 
  itemRootName : 'system',
  actionTypeBase : 'SYSTEM', 
  parentIdKey : 'projectId', 
  humanItemName : 'System' 
} )
